module.exports = __webpack_public_path__ + "static/media/happy.c2a1c862.jpeg";